import { cva } from "cva";

export const headerMobileMenuToggleStyles = cva({
  base: "block p-8 -mr-8 cursor-pointer md:hidden",
});

export const headerMenuToggleIconStyles = cva({
  base: "w-24 h-24 grid-contain place-items-center",
});

export const headerMenuToggleIconLineStyles = cva({
  base: "block h-2 bg-content-primary rounded-full transition-all duration-650 ease-spring motion-reduce:transition-none",
  variants: {
    position: {
      start: "w-[85%]",
      center: "w-full",
      end: "w-[85%]",
    },
    menuOpen: {
      true: "",
      false: "",
    },
  },
  compoundVariants: [
    {
      position: "start",
      menuOpen: false,
      class: "-translate-y-6",
    },
    {
      position: "start",
      menuOpen: true,
      class: "translate-y-0 rotate-45",
    },
    {
      position: "end",
      menuOpen: false,
      class: "translate-y-6",
    },
    {
      position: "end",
      menuOpen: true,
      class: "translate-y-0 -rotate-45",
    },
    {
      position: "center",
      menuOpen: true,
      class: "opacity-0 scale-x-0",
    },
    {
      position: "center",
      menuOpen: false,
      class: "opacity-100",
    },
  ],
});
